import axios from '@/extra-functions/axios.extra'
import { errorHandler } from './../extra-functions/store.extra'

const state = {
  list: [],
  allList: [],
  index: 0,
  channelUpdate: '',
  dataCount: 0,
  storing: false,
  fetching: false,
  fetchingAll: false,
  countingData: false,
  updating: false,
  fetchErrors: [],
  fetchAllErrors: [],
  countingDataErrors: [],
  updateErrors: [],
  storeErrors: [],
  storeSuccess: false,
  updateSuccess: false,
}

const mutations = {
  SET_LIST (state, payload) {
    state.list = payload
  },
  CHANNEL_UPDATED (state, payload) {
    state.channelUpdate = payload
  },
  SET_ALL_LIST (state, payload) {
    state.allList = payload
  },
  EMPTY_LIST (state, payload) {

  },
  SET_INDEX (state, payload) {

  },
  SET_DATA_COUNT (state, payload) {
    state.dataCount = payload
  },
  DATA_COUNTING_TRUE (state) {
    state.countingData = true
  },
  DATA_COUNTING_FALSE (state) {
    state.countingData = false
  },
  SET_COUNTING_DATA_ERRORS (state, payload) {
    state.countingDataErrors = payload
  },
  SET_FETCHING_ERRORS (state, payload) {
    state.fetchErrors = payload
  },
  SET_FETCHING_ALL_ERRORS (state, payload) {
    state.fetchAllErrors = payload
  },
  SET_STORING_ERRORS (state, payload) {
    state.storeErrors = payload
  },
  SET_UPDATING_ERRORS (state, payload) {
    state.updateErrors = payload
  },
  UPDATE_SUCCESS_TRUE (state) {
    state.updateSuccess = true
  },
  UPDATE_SUCCESS_FALSE (state) {
    state.updateSuccess = false
  },
  STORE_SUCCESS_TRUE (state) {
    state.storeSuccess = true
  },
  STORE_SUCCESS_FALSE (state) {
    state.storeSuccess = false
  },
  FETCHING_ALL_TRUE (state) {
    state.fetchingAll = true
  },
  FETCHING_ALL_FALSE (state) {
    state.fetchingAll = false
  },
  FETCHING_TRUE (state) {
    state.fetching = true
  },
  FETCHING_FALSE (state) {
    state.fetching = false
  },
  UPDATING_TRUE (state) {
    state.updating = true
  },
  UPDATING_FALSE (state) {
    state.updating = false
  },
  STORING_TRUE (state) {
    state.storing = true
  },
  STORING_FALSE (state) {
    state.storing = false
  },
}

const actions = {
  fetch ({ state, commit, rootState }, { index, count }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ERRORS', [])
    if (!state.fetching) {
      commit('FETCHING_TRUE')
      ax.get(`units/${index}/${count}`)
        .then(({ data }) => {
          commit('SET_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_FALSE'))
    }
  },
  fetchAll ({ state, commit, rootState }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_FETCHING_ALL_ERRORS', [])
    if (!state.fetchingAll) {
      commit('FETCHING_ALL_TRUE')
      ax.get('units/all')
        .then(({ data }) => {
          commit('SET_ALL_LIST', data)
        }).catch(errors => {
          commit('SET_FETCHING_ALL_ERRORS', errorHandler(errors))
        }).then(() => commit('FETCHING_ALL_FALSE'))
    }
  },
  fetchDataCount ({ state, commit, rootState }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_COUNTING_DATA_ERRORS', [])
    if (!state.countingData) {
      commit('DATA_COUNTING_TRUE')
      ax.get('units/count')
        .then(({ data }) => {
          commit('SET_DATA_COUNT', data)
        }).catch(errors => {
          commit('SET_COUNTING_DATA_ERRORS', errorHandler(errors))
        }).then(() => commit('DATA_COUNTING_FALSE'))
    }
  },
  store ({ state, commit, rootState }, data) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_STORING_ERRORS', [])
    if (!state.storing) {
      commit('STORE_SUCCESS_FALSE')
      commit('STORING_TRUE')
      ax.post('units', data)
        .then(({ data }) => {
          commit('STORE_SUCCESS_TRUE')
        }).catch(errors => {
          commit('SET_STORING_ERRORS', errorHandler(errors))
        }).then(() => {
          commit('STORING_FALSE')
        })
    }
  },
  channelUpdated ({ state, commit }) {
    commit('CHANNEL_UPDATED', new Date().getTime())
  },
  update ({ state, commit, rootState }, { id, data }) {
    const token = rootState.auth.token
    const ax = axios(token)
    commit('SET_UPDATING_ERRORS', [])
    if (!state.updating) {
      commit('UPDATE_SUCCESS_FALSE')
      commit('UPDATING_TRUE')
      ax.put(`units/${id}`, data)
        .then(({ data }) => {
          commit('UPDATE_SUCCESS_TRUE')
        }).catch(errors => {
            commit('SET_UPDATING_ERRORS', errorHandler(errors))
        }).then(() => commit('UPDATING_FALSE'))
    }
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    strict: true,
}
